import { render, staticRenderFns } from "./AbrirTarimaComponent.vue?vue&type=template&id=6e42f510&"
import script from "./AbrirTarimaComponent.vue?vue&type=script&lang=js&"
export * from "./AbrirTarimaComponent.vue?vue&type=script&lang=js&"
import style0 from "./AbrirTarimaComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports